/**
 * @summary - Component that Provides Vendor Form Page
 * @author Purushothaman T
 * @since 2024-07-29
 */
import { Grid } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DefaultCard } from "../../assets/styled-components/card";
import { ifacSecurityURL, MasterGraph } from "../../utility/apiURLS";
import { validations, vendor } from "../../utility/constants/errors/messages";
import { dialogContent } from "../../utility/message";
import {
  getAuthToken,
  getcompanyId,
  getuserId,
} from "../../utility/tokenUtility";
import utilities from "../../utility/utilities";
import ActionButtons from "../commoncomponents/ActionButtons";
import CustomDialog from "../commoncomponents/CustomDialog";
import PageTitle from "../commoncomponents/PageTitle";
import VendorAddress from "./VendorAddress";
import VendorContact from "./VendorContact";
import VendorInfo from "./VendorInfo";

const VendorDetailsForm = () => {
  const token = getAuthToken("id_token");
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const [vendorCode, setVendorCode] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [status, setStatus] = useState("");
  const [companyType, setCompanyType] = useState("");
  const [effectiveDate, setEffectiveDate] = useState("");
  const [category, setCategory] = useState("");
  const [group, setGroup] = useState("");
  const [preference, setPreference] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [state, setState] = useState("");
  const [postcode, setPostcode] = useState("");
  const [country, setCountry] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [errors, setErrors] = useState({
    vendorName: false,
    vendorCode: false,
    status: false,
    companyType: false,
    category: false,
    effectiveDate: false,
    services: false,
    classes: false,
    group: false,
    preference: false,
    address1: false,
    address2: false,
    state: false,
    postcode: false,
    country: false,
    email: false,
    phone: false,
    contactPerson: false,
  });
  const [errorMessages, setErrorMessages] = useState({
    vendorCode: "",
    vendorName: "",
    status: "",
    companyType: "",
    category: "",
    group: "",
    preference: "",
    services: "",
    classes: "",
    effectiveDate: "",
    address1: "",
    address2: "",
    state: "",
    postcode: "",
    country: "",
    email: "",
    phone: "",
    contactPerson: "",
  });
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [emailMultiValues, setEmailMultiValues] = useState([]);
  const [phoneMultiValues, setPhoneMultiValues] = useState([]);
  const [contactPersonMultiValues, setContactPersonMultiValues] = useState([]);
  const [isChanged, setIsChanged] = useState(false);
  const [isAddNew, setIsAddNew] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [contentDialog, setContentDialog] = useState({});
  const [openValidationDialog, setOpenValidationDialog] = useState(false);

  const [statusOptions, setStatusOptions] = useState([]);
  const [clearField, setClearField] = useState(false)
  const [vendorOptions, setVendorOptions] = useState([])
  const [companyTypeOptions, setCompanyTypeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [preferenceOptions, setPreferenceOptions] = useState([]);
  const [id, setId] = useState("");

  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [isNavigate, setIsNavigate] = useState(true)
  const [enableSubmit, setEnableSubmit] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state) {
      const { id, isEditMode, isViewMode } = location.state;
      setId(id);
      setIsEdit(isEditMode);
      setIsView(isViewMode);
    }
  }, [location.state]);

  useEffect(() => {
    fetchOptions();
    if (isEdit || isView) {
      fetchData();
    } else {
      fetchVendorOptions()
    }
  }, [isEdit, isView]);

  const fetchData = async () => {
    try {

      const response = await axios.get(
        `${MasterGraph}/api/maspomvendors/${id}`,
        config
      );
      setVendorCode({ label: response.data.vendorcode, ...response.data });
      setVendorName(response.data.vendorname);
      setEffectiveDate(
        utilities.formatDate({
          dateString: response.data.vendoreffectivedate,
          format: "dd/mm/yyyy",
          dbdate: true,
        })
      );
      setStatus(response.data.maspomvendorstatusId);
      setCompanyType(response.data.maspomvendorcompanytypeId);
      setCategory(response.data.maspomvendorcategoryId);
      setGroup(response.data.maspomvendorgroupId);
      setPreference(response.data.maspomvendorpreferenceId);
      setAddress1(response.data.vendoraddress1);
      setAddress2(response.data.vendoraddress2);
      setState(response.data.vendorstate);
      setPostcode(response.data.vendorpostcode);
      setCountry(response.data.vendorcountry);
      setEmailMultiValues(
        response.data.vendoremail == ""
          ? []
          : response.data.vendoremail?.split(", ")
      );
      setPhoneMultiValues(
        response.data.vendorphoneno == ""
          ? []
          : response.data.vendorphoneno?.split(", ")
      );
      setContactPersonMultiValues(
        response.data.vendorcontactperson == ""
          ? []
          : response.data.vendorcontactperson?.split(", ")
      );
      setSelectedClasses(
        response.data.classcodes == ""
          ? []
          : response.data.classcodes?.split(", ")
      );
      setSelectedServices(
        response.data.servicecode == ""
          ? []
          : response.data.servicecode?.split(", ")
      );
    } catch (error) {
      console.error("Error fetching vendor details:", error);
    }
  };
  useEffect(() => {
    if (statusOptions.length > 0) {
      if (!status?.id) {
        setStatus((prevStatus) =>
          statusOptions.find((data) => data.id === prevStatus)
        );
      }
    }
    if (companyTypeOptions.length > 0) {
      if (!companyType?.id) {
        setCompanyType((prevCompanyType) =>
          companyTypeOptions.find((data) => data.id === prevCompanyType)
        );
      }
    }
    if (categoryOptions.length > 0) {
      if (!category?.id) {
        setCategory((prevCategory) =>
          categoryOptions.find((data) => data.id === prevCategory)
        );
      }
    }
    if (groupOptions.length > 0) {
      if (!group?.id) {
        setGroup((prevGroup) =>
          groupOptions.find((data) => data.id === prevGroup)
        );
      }
    }
    if (preferenceOptions.length > 0) {
      if (!preference?.id) {
        setPreference((prevPreference) =>
          preferenceOptions.find((data) => data.id === prevPreference)
        );
      }
    }
  }, [
    statusOptions,
    companyTypeOptions,
    categoryOptions,
    groupOptions,
    preferenceOptions,
  ]);

  const fetchOptions = async () => {
    try {
      const [
        statusResponse,
        companyTypeResponse,
        categoryResponse,
        groupResponse,
        preferenceResponse,
      ] = await Promise.all([
        axios.get(`${MasterGraph}/api/maspomvendorstatuses`, config),
        axios.get(`${MasterGraph}/api/maspomvendorcompanytypes`, config),
        axios.get(`${MasterGraph}/api/maspomvendorcategories`, config),
        axios.get(`${MasterGraph}/api/maspomvendorgroups`, config),
        axios.get(`${MasterGraph}/api/maspomvendorpreferences`, config),
      ]);
      setStatusOptions(
        statusResponse.data
          .map((data) => {
            return {
              label: data.vendorStatus,
              value: data.vendorStatus,
              id: data.id,
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label))
      );
      setCompanyTypeOptions(
        companyTypeResponse.data
          .map((data) => {
            return {
              label: data.typeDetails,
              value: data.typeDetails,
              id: data.id,
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label))
      );
      setCategoryOptions(
        categoryResponse.data
          .map((data) => {
            return {
              label: data.categoryName,
              value: data.categoryName,
              id: data.id,
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label))
      );
      setGroupOptions(
        groupResponse.data
          .map((data) => {
            return {
              label: data.vendorGroup,
              value: data.vendorGroup,
              id: data.id,
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label))
      );
      setPreferenceOptions(
        preferenceResponse.data
          .map((data) => {
            return {
              label: data.vendorPreference,
              value: data.vendorPreference,
              id: data.id,
            };
          })
          .sort((a, b) => a.label.localeCompare(b.label))
      );
    } catch (e) {
      console.log(e);
    }
  };

  const handleSubmit = () => {
    const requiredFields = [
      {
        field: "vendorCode",
        value: vendorCode,
        message: vendor.vendorcode.required,
      },
      { field: "status", value: status, message: vendor.status.required },
      {
        field: "companytype",
        value: companyType,
        message: vendor.companytype.required,
      },
      { field: "category", value: category, message: vendor.category.required },
      { field: "group", value: group, message: vendor.group.required },
      {
        field: "preference",
        value: preference,
        message: vendor.preference.required,
      },
      {
        field: "effectiveDate",
        value: effectiveDate,
        message: vendor.effectiveDate.required,
      },
      { field: "address1", value: address1, message: vendor.address1.required },
      { field: "country", value: country, message: vendor.country.required },
      { field: "state", value: state, message: vendor.state.required },
      { field: "postcode", value: postcode, message: vendor.postcode.required },
    ];
    const unsavedFields = [
      { field: "email", value: email, message: validations.clickIcon },
      { field: "phone", value: phone, message: validations.clickIcon },
      {
        field: "contactPerson",
        value: contactPerson,
        message: validations.clickIcon,
      },
    ];
    let isValid = true;
    requiredFields.forEach((field) => {
      if (!field.value) {
        isValid = false;
        setErrors((prev) => ({ ...prev, [field.field]: true }));
        setErrorMessages((prev) => ({ ...prev, [field.field]: field.message }));
      }
    });
    unsavedFields.forEach((field) => {
      if (field.value) {
        isValid = false;
        setErrors((prev) => ({ ...prev, [field.field]: true }));
        setErrorMessages((prev) => ({ ...prev, [field.field]: field.message }));
      }
    });

    // Check if selectedClasses and selectedServices are empty
    if (selectedClasses.length === 0) {
      isValid = false;
      setErrors((prev) => ({ ...prev, classes: true }));
      setErrorMessages((prev) => ({ ...prev, classes: vendor.class.required }));
    }
    if (selectedServices.length === 0) {
      isValid = false;
      setErrors((prev) => ({ ...prev, services: true }));
      setErrorMessages((prev) => ({
        ...prev,
        services: vendor.service.required,
      }));
    }
    // Check if all error messages are empty
    if (!Object.values(errorMessages).every((value) => value === "")) {
      isValid = false;
    }
    // If form is valid, proceed with saving
    if (isValid) {
      handleSave();
    }
  };

  const formData = {
    vendorCode,
    vendorName,
    status,
    companyType,
    category,
    group,
    preference,
    effectiveDate,
    address1,
    address2,
    country,
    state,
    postcode,
    emailMultiValues,
    phoneMultiValues,
    contactPersonMultiValues,
    selectedClasses,
    selectedServices,
    email,
    phone,
    contactPerson,
  };
  const areAllEmpty = () => {
    for (const key in formData) {
      if (Array.isArray(formData[key])) {
        if (formData[key].length !== 0) {
          return false;
        }
      } else if (formData[key]) {
        return false;
      }
    }
    return true;
  };

  const handleCancel = () => {
    if (!isChanged || areAllEmpty()) {
      navigate("/vendordetails");
    }
    setOpenDialog(true);
    setContentDialog(dialogContent.modified);
  };

  const fetchVendorOptions = async () => {

    try {
      const vendorResponse = await axios.get(`${ifacSecurityURL}/api/GraphUserRegistration/GetSecuserregisterVendor`, config)

      setVendorOptions(vendorResponse?.data.map((v) => ({
        label: `${v.employeeCode} - ${v.firstName}`,
        value: v.employeeCode,
        ...v
      })))
    } catch (error) {
      console.error("Error fetching options:", error);
    }

  }

  const handleAddNew = () => {
    if (isChanged) {
      setIsAddNew(true);
      setOpenDialog(true);
      setContentDialog(dialogContent.modified);
    } else {
      setDeafault();
    }
  };

  const handleDialogClose = () => {
    if (isChanged) {
      setOpenDialog(false);
    }
    if (isAddNew) {
      setIsAddNew(false);
    }
  };

  const setDeafault = () => {
    setClearField(true)
    setEnableSubmit(true);
    setEmail("");
    setPhone("");
    setContactPerson("");
    setVendorCode("");
    setVendorName("");
    setStatus("");
    setCompanyType("");
    setCategory("");
    setGroup("");
    setPreference("");
    setEffectiveDate("");
    setAddress1("");
    setAddress2("");
    setState("");
    setPostcode("");
    setCountry("");
    setSelectedClasses([]);
    setSelectedServices([]);
    setEmailMultiValues([]);
    setPhoneMultiValues([]);
    setContactPersonMultiValues([]);
    setErrorMessages({});
    setErrors({});
    setIsAddNew(false);
    setIsChanged(false);
  };

  const handleSave = async () => {
    const userId = getuserId();
    const companyId = getcompanyId();

    const postData = {
      vendorCode: vendorCode?.label,
      vendorName,
      companyid: companyId,
      modifiedby: userId,
      maspomvendorstatusId: status.id,
      maspomvendorcompanytypeId: companyType.id,
      maspomvendorcategoryId: category.id,
      maspomvendorgroupId: group.id,
      maspomvendorpreferenceId: preference.id,
      vendoreffectivedate: utilities.formatDate({
        dateString: effectiveDate,
        format: "YYYY-MM-DD",
        includeTime: true,
      }),
      vendoraddress1: address1,
      vendoraddress2: address2,
      vendorstate: state,
      vendorpostcode: postcode,
      vendorcountry: country,
      vendoremail: emailMultiValues?.join(", "),
      vendorphoneno: phoneMultiValues?.join(", "),
      vendorcontactperson: contactPersonMultiValues?.join(", "),
      classcodes: selectedClasses?.join(", "),
      servicecode: selectedServices?.join(", "),
      userId: isEdit ? vendorCode?.userId : vendorCode?.id
    };
    if (isEdit) {
      postData["id"] = id;
    } else {
      postData["createdby"] = userId;
    }

    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };
      const endpoint = isEdit
        ? `${MasterGraph}/api/maspomvendors/${id}`
        : `${MasterGraph}/api/maspomvendors`;

      let result = await axios({
        method: isEdit ? "put" : "post",
        url: endpoint,
        data: postData,
        headers: config.headers,
      });
      if (result.status === 201) {
        setContentDialog(dialogContent.saved);
        setIsChanged(false);
        setOpenValidationDialog(true);
        setEnableSubmit(false);
      }
      if (result.status === 200) {
        setContentDialog(dialogContent.updated);
        setIsChanged(false);
        setOpenValidationDialog(true);
      }
    } catch (error) {
      console.log(error);
      if (error.response.status === 400) {
        setOpenValidationDialog(true);
        setContentDialog(error.response.data.detail || validations.default);
      }
    }
  };


  const handleDescClear = () => {
    if (isChanged) {
      setOpenDialog(true);
      setContentDialog(dialogContent.modified);
      setIsNavigate(false)
    } else {
      setDeafault()
    }
  };

  const handleDialogConfirm = () => {
    setOpenValidationDialog(false);
    setOpenDialog(false);
    if (isChanged && !openValidationDialog && !isAddNew) {
      if (!isNavigate) {
        setOpenDialog(false);
        setIsNavigate(true)
        setDeafault()
      } else {
        navigate("/vendordetails");
      }
    }
    if (isAddNew) {
      setDeafault();
    }
  };

  return (
    <>
      <PageTitle
        title="Create Vendor Details"
        editTitle={"Edit Vendor Details"}
        viewTitle={"View Vendor Details"}
        isEdit={isEdit}
        isView={isView}
      />
      <DefaultCard>
        <Grid container spacing={4}>
          <VendorInfo
            setDeafault={setDeafault}
            setIsChanged={setIsChanged}
            errors={errors}
            errorMessages={errorMessages}
            vendorName={vendorName}
            vendorCode={vendorCode}
            status={status}
            companyType={companyType}
            category={category}
            group={group}
            categoryOptions={categoryOptions}
            statusOptions={statusOptions}
            companyTypeOptions={companyTypeOptions}
            groupOptions={groupOptions}
            preferenceOptions={preferenceOptions}
            effectiveDate={effectiveDate}
            preference={preference}
            setVendorCode={setVendorCode}
            setVendorName={setVendorName}
            setStatus={setStatus}
            setCategory={setCategory}
            setCompanyType={setCompanyType}
            setEffectiveDate={setEffectiveDate}
            setPreference={setPreference}
            setGroup={setGroup}
            setErrors={setErrors}
            setErrorMessages={setErrorMessages}
            selectedServices={selectedServices}
            setSelectedServices={setSelectedServices}
            selectedClasses={selectedClasses}
            setSelectedClasses={setSelectedClasses}
            isEdit={isEdit}
            isView={isView}
            handleDescClear={handleDescClear}
            vendorOptions={vendorOptions}
            clearField={clearField}
            setClearField={setClearField}
          />

          <VendorAddress
            setIsChanged={setIsChanged}
            address1={address1}
            address2={address2}
            state={state}
            postcode={postcode}
            country={country}
            isView={isView}
            setAddress1={setAddress1}
            setAddress2={setAddress2}
            setState={setState}
            setPostcode={setPostcode}
            setCountry={setCountry}
            errors={errors}
            errorMessages={errorMessages}
            setErrors={setErrors}
            setErrorMessages={setErrorMessages}
          />
        </Grid>

        <VendorContact
          setIsChanged={setIsChanged}
          isChanged={isChanged}
          email={email}
          phone={phone}
          setErrorMessages={setErrorMessages}
          setErrors={setErrors}
          contactPerson={contactPerson}
          errors={errors}
          errorMessages={errorMessages}
          setEmail={setEmail}
          setPhone={setPhone}
          setContactPerson={setContactPerson}
          isView={isView}
          emailMultiValues={emailMultiValues}
          setEmailMultiValues={setEmailMultiValues}
          phoneMultiValues={phoneMultiValues}
          setPhoneMultiValues={setPhoneMultiValues}
          constactPersonMultiValues={contactPersonMultiValues}
          setContactPersonMultiValues={setContactPersonMultiValues}
        />

        <ActionButtons
          handleCancel={handleCancel}
          handleSubmit={handleSubmit}
          handleAddNew={handleAddNew}
          enableSubmit={enableSubmit}
          isEdit={isEdit}
          isView={isView}
        />
      </DefaultCard>
      <CustomDialog
        cancelBtn={"No"}
        open={openDialog}
        onConfirm={handleDialogConfirm}
        content={contentDialog}
        onClose={handleDialogClose}
        confirmBtn={"Yes"}
      />
      <CustomDialog
        open={openValidationDialog}
        onConfirm={handleDialogConfirm}
        content={contentDialog}
        onClose={handleDialogClose}
        confirmBtn={"Ok"}
      />
    </>
  );
};

export default VendorDetailsForm;
